import { RegisterPage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/register'].update({
        staticData: { title: { webinar: 'Title.RegisterForWebinar' } },
        component: RegisterPage
    });
};
